<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
          <vs-tab :label="$t('ReviewQueue')" class="mt-1">
            <review-queue
              :tabIndex="0"
              v-if="isRender[0]"
              :numberRowsPerPage="numberRowsPerPage"
            ></review-queue>
          </vs-tab>
          <vs-tab
            :label="$t('WaitingForDischargePermissionConfirmation')"
            class="mt-1"
          >
            <confirmed
              :tabIndex="1"
              v-if="isRender[1]"
              :numberRowsPerPage="numberRowsPerPage"
            ></confirmed>
          </vs-tab>
          <vs-tab :label="$t('Processing')" class="mt-1">
            <processing
              :tabIndex="2"
              v-if="isRender[2]"
              :numberRowsPerPage="numberRowsPerPage"
            ></processing>
          </vs-tab>
          <vs-tab :label="$t('Sent')" class="mt-1">
            <send
              :tabIndex="3"
              v-if="isRender[3]"
              :numberRowsPerPage="numberRowsPerPage"
            ></send>
          </vs-tab>
          <vs-tab :label="$t('Delivered')" class="mt-1">
            <delivered
              :tabIndex="4"
              v-if="isRender[4]"
              :numberRowsPerPage="numberRowsPerPage"
            ></delivered>
          </vs-tab>
          <vs-tab :label="$t('IgnoredOrders')" class="mt-1">
            <ignored-orders
              :tabIndex="5"
              v-if="isRender[5]"
              :numberRowsPerPage="numberRowsPerPage"
            ></ignored-orders>
          </vs-tab>
          <vs-tab :label="$t('ReturnedOrders')" class="mt-1">
            <returned-orders
              :tabIndex="6"
              v-if="isRender[6]"
              :numberRowsPerPage="numberRowsPerPage"
            ></returned-orders>
          </vs-tab>
          <vs-tab :label="$t('AllOrders')" class="mt-1">
            <all-orders
              :tabIndex="7"
              v-if="isRender[7]"
              :numberRowsPerPage="numberRowsPerPage"
            ></all-orders>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import ReviewQueue from "./ReviewQueue/Index.vue";
import Confirmed from "./Confirmed/Index.vue";
import Processing from "./Processing/Index.vue";
import Send from "./Send/Index.vue";
import Delivered from "./Delivered/Index.vue";
import IgnoredOrders from "./IgnoredOrders/Index.vue";
import ReturnedOrders from "./ReturnedOrders/Index.vue";
import AllOrders from "./AllOrders/Index.vue";
export default {
  name: "basketManagement_WebSiteBaskets_Index",
  components: {
    ReviewQueue,
    Confirmed,
    Processing,
    Send,
    Delivered,
    IgnoredOrders,
    ReturnedOrders,
    AllOrders,
  },
  data() {
    return {
      isRender: [],
      referencePageInfo: {},
      numberRowsPerPage: "",
      tabIndex: 0,
    };
  },

  mounted() {
    this.isRender = Array(9).fill(false);
    setTimeout(() => {
      if (this.$route.query.referencePageInfo) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(9).fill(true);
    }, 150);
  },
};
</script>
